import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FilterKeys, navigateSphereWithFilters } from '@common/enums/query-params/filters';
import { useAppDispatch, useAppSelector } from '../../store';
import { selectInviteData, selectUser } from '../../store/general/general-slice-selectors';
import UserForm from '../user/UserForm';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { validateUserInvite } from '../../store/general/general-actions';
import CustomAlert from '@common/components/Feedback/CustomAlert';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';

const RegisterPage: React.FC = () => {
  const { t } = useTranslation();

  const [filterParams] = useSearchParams();
  const robotId = filterParams.get(FilterKeys.RobotId);
  const token = filterParams.get(FilterKeys.InviteToken);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const userData = useAppSelector((state) => selectUser(state));
  const inviteData = useAppSelector((state) => selectInviteData(state));

  useEffect(() => {
    if (inviteData.rest.getStatus === HttpFetchStatus.Idle) {
      dispatch(validateUserInvite({ robotId: robotId ?? '', token: token ?? '' }));
    }
  }, [dispatch, inviteData.rest.getStatus, robotId, token]);

  useEffect(() => {
    if ((userData.data?.id ?? '').length > 0) {
      navigate(navigateSphereWithFilters('', true, { rid: robotId ?? undefined }));
    }
  }, [navigate, robotId, userData.data?.id]);

  const closeRegisterHandler = () => {
    navigate(navigateSphereWithFilters('', true, { rid: robotId ?? undefined }));
  };

  const isValidatingInvite =
    inviteData.rest.getStatus === HttpFetchStatus.Idle ||
    inviteData.rest.getStatus === HttpFetchStatus.Loading;

  return (
    <React.Fragment>
      <UserForm
        open={true}
        onClose={closeRegisterHandler}
        memberRegistration={{
          organizationId: inviteData.organizationId,
          filters: { rid: robotId ?? '', it: token ?? '' },
          formDisabled: inviteData.rest.getStatus !== HttpFetchStatus.Success,
          alert: (
            <CustomAlert
              icon={isValidatingInvite ? <CircularProgress size={24} /> : undefined}
              severity={
                isValidatingInvite
                  ? 'info'
                  : inviteData.rest.getStatus === HttpFetchStatus.Failed
                    ? 'error'
                    : undefined
              }
              header={
                isValidatingInvite
                  ? t('loading-validating-invite')
                  : inviteData.rest.getStatus === HttpFetchStatus.Failed
                    ? t(inviteData.rest.getError?.message ?? '')
                    : t('info-registration-ready')
              }
            />
          ),
        }}
      />
    </React.Fragment>
  );
};

export default RegisterPage;
